<template>
  <div>
    <cpxlist :status='2'/>
  </div>
</template>

<script>
import cpxlist from '@/components/cpx/cpxlist';
export default {
    name:'cpxruning',
    components:{
      cpxlist,
    }
}
</script>

<style>

</style>